/**
 * @generated SignedSource<<9d5c027ee3a79dbaf1b3bac877c2ffb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type XeroSignupContainer_Query$variables = {};
export type XeroSignupContainer_Query$data = {
  readonly viewer: {
    readonly id: string;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"XeroSignupContainer_viewer">;
  } | null;
};
export type XeroSignupContainer_Query = {
  variables: XeroSignupContainer_Query$variables;
  response: XeroSignupContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "signup_xero"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"signup_xero\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "XeroSignupContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "XeroSignupContainer_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "XeroSignupContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e02d8300487c7f4a4a6da60008fb010a",
    "id": null,
    "metadata": {},
    "name": "XeroSignupContainer_Query",
    "operationKind": "query",
    "text": "query XeroSignupContainer_Query {\n  viewer {\n    id\n    component(name: \"signup_xero\")\n    ...XeroSignupContainer_viewer\n  }\n}\n\nfragment XeroSignupContainer_viewer on Viewer {\n  id\n  actualPersonId\n}\n"
  }
};
})();

(node as any).hash = "3a8b5d2acf34d7c7b4955c4718a85f53";

export default node;
